import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'
//import { firestorePlugin } from 'vuefire'

Vue.config.productionTip = false

let app=''
const firebaseConfig = {
    apiKey: "AIzaSyCI-ojcs5FzBERFWk-YdSs53Zx6QQr3mPg",
    authDomain: "campusbox-e0794.firebaseapp.com",
    databaseURL: "https://campusbox-e0794.firebaseio.com",
    projectId: "campusbox-e0794",
    storageBucket: "campusbox-e0794.appspot.com",
    messagingSenderId: "54460801669",
    appId: "1:54460801669:web:1d2705c676165892"
};

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        /* eslint-disable no-new */
        app = new Vue({
            router,
            render: h => h(App)
        }).$mount('#app');
    }
});